export const selectTATMonitoringDetailedState = (state) =>
  state.tatMonitoringDetailed || {};

export const selectTableData = (state) =>
  selectTATMonitoringDetailedState(state).detailedData || [];

export const selectLoading = (state) =>
  selectTATMonitoringDetailedState(state).loading || false;